import type { NewsRaw } from "epsm-api-types/models";
import { getNewsEstimate } from "../getNewsEstimate";

export function getClassNameForEstimate({
	data,
}: {
	data: NewsRaw | Partial<NewsRaw> | null;
}) {
	if (!data) return "";

	const result = getNewsEstimate(data.sentiment, data.significancy);

	if (result === null) return "";

	return `estimate-color-${result.color} news-cell`;
}
